import { useState, useEffect } from "react";
import { useTranslation } from "../i18n/i18n";
import AppHeader from "../components/AppHeader/AppHeader";
import LoginForm from "../components/AuthForm/LoginForm";
import RegisterForm from "../components/AuthForm/RegisterForm";
import Modal from "../components/Modal/Modal";

const AuthPage = () => {
	const [formType, setFormType] = useState(null);
	const [currentFormType, setCurrentFormType] = useState(null); // State to maintain form type during animation
	const { translate } = useTranslation();

	useEffect(() => {
		// Add class to html on mount
		document.documentElement.classList.add("auth-page-active");

		// Clean up on unmount
		return () => {
			document.documentElement.classList.remove("auth-page-active");
		};
	}, []);

	const openModal = type => {
		setFormType(type);
		setCurrentFormType(type);
	};

	const closeModal = () => {
		setFormType(null);
		// Don't reset currentFormType immediately to allow animation
	};

	// Reset currentFormType when modal is completely closed
	const handleModalClose = () => {
		closeModal();
		// Delay to ensure closing animation is complete
		setTimeout(() => {
			setCurrentFormType(null);
		}, 400); // Matches CSS animation duration (0.3s + margin)
	};

	return (
		<div className="content auth-page-container auth-page">
			<AppHeader />

			<button onClick={() => openModal("login")} className="primary-button">
				{translate("register.loginLink")}
			</button>

			<h3 className="application-description">
				{translate("login.noAccount")}
			</h3>

			<button onClick={() => openModal("register")} className="primary-button">
				{translate("login.signupLink")}
			</button>

			<Modal isOpen={!!formType} onClose={handleModalClose}>
				{currentFormType === "login" && <LoginForm />}
				{currentFormType === "register" && <RegisterForm />}
			</Modal>
		</div>
	);
};

export default AuthPage;
